// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__Si8od","avatar":"FeatureCard_avatar__xAmmj","button":"FeatureCard_button__Gq-5g"};